module.exports = __webpack_public_path__ + "static/media/corporateFamily.6083c5d1.png";